/**
 * Created by Languagenut on 21/03/2019.
 */


import React  from 'react';
import {ButtonGroup , Navbar , Nav , NavDropdown , Form , Button , FormControl} from 'react-bootstrap';

export default class Navigation extends React.Component {


    constructor(props) {
        super();
        this.props = props;
        this.state = {

        };
    }

    render(){


        //return null;

        return <Navbar className="shadow mx-auto" bg="light" expand="lg">

            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse className="justify-content-center" id="basic-navbar-nav">
                <Nav className="justify-content-center">
                    <ButtonGroup>
                        <Button>All Categories</Button>
                        <Button>Games</Button>
                        <Button>Projects</Button>
                        <Button>Projects</Button>
                        <Button>Websites</Button>
                    </ButtonGroup>
                </Nav>
            </Navbar.Collapse>
            <Form inline>
                <FormControl type="text" placeholder="Search" className="mr-sm-2" />
                <Button variant="outline-success">Search</Button>
            </Form>
        </Navbar>
    }
}